import React from "react";
import { Link } from "react-router-dom";
import Icon from "../icons/Icons";
import "./Offerings.css";

const plans = [
  {
    title: "Startup Launchpad",
    subtitle: "Perfect for early-stage startups",
    points: [
      "Full AWS Infrastructure Setup & Management",
      "Continuous Cost Optimization",
      "Slack & Email Support (12hr response)",
      "Monthly Architecture Reviews",
    ],
    price: 5000,
    popular: false,
  },
  {
    title: "Scale-Up Accelerator",
    subtitle: "Most popular for growing startups",
    points: [
      "Everything in Startup Launchpad",
      "24/7 Infrastructure Monitoring",
      "Priority Support (4hr response)",
      "Weekly Architecture Reviews",
    ],
    price: 10000,
    popular: true,
  },
  {
    title: "Growth Engine",
    subtitle: "For scale-up ready companies",
    points: [
      "Everything in Scale-Up Accelerator",
      "Dedicated Slack Channel",
      "Direct Phone Support",
      "Custom SLA Coverage",
      "Dedicated Engineer",
    ],
    price: 15000,
    popular: false,
  },
];

const onDemand = [
  {
    icon: "bolt",
    title: "Quick AWS Solutions",
    description:
      "Same-day expert help with your AWS challenges. Pay only for what you need - perfect for startups watching their budget.",
  },
  {
    icon: "badgeDollar",
    title: "Cost-Effective Projects",
    description:
      "Fixed-price AWS projects with clear ROI. Migrations, cost-cutting, or performance optimization - know exactly what you'll get and pay.",
  },
  {
    icon: "shield",
    title: "Fast-Track Compliance",
    description:
      "Get SOC2 & HIPAA ready in weeks, not months. Streamlined process that won't slow down your startup's momentum.",
  },
  {
    icon: "book",
    title: "Rapid Team Training",
    description:
      "Quick, focused AWS training for your team. Learn exactly what you need to know to scale your startup efficiently.",
  },
];

const Offerings = () => {
  return (
    <React.Fragment>
      <section id="monthly-services" className="section">
        <div className="container">
          <div className="section-head">
            <p className="eyebrow">monthly packages</p>
            <h2 className="h2">Your AWS team, on subscription</h2>
            <p className="lede">
              Save 50-70% vs hiring in-house AWS experts. Get enterprise-grade
              cloud management at startup-friendly prices — month to month, no
              long-term commitment.
            </p>
          </div>
          <div className="plans-grid">
            {plans.map((plan) => (
              <div
                className={`card plan ${plan.popular ? "plan-popular" : ""}`}
                key={plan.title}
              >
                {plan.popular && <span className="plan-badge">most popular</span>}
                <h3 className="h3">{plan.title}</h3>
                <p className="plan-subtitle">{plan.subtitle}</p>
                <div className="plan-price">
                  <span className="plan-price-from">starting from</span>
                  <span className="plan-price-value">
                    ${plan.price.toLocaleString()}
                  </span>
                  <span className="plan-price-period">/month</span>
                </div>
                <ul className="plan-points">
                  {plan.points.map((point) => (
                    <li key={point}>
                      <Icon name="check" size={15} strokeWidth={2.2} />
                      {point}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/contact"
                  className={`btn btn-block ${
                    plan.popular ? "btn-primary" : "btn-outline"
                  }`}
                >
                  Get started
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="on-demand" className="section">
        <div className="container">
          <div className="section-head">
            <p className="eyebrow">consulting & training</p>
            <h2 className="h2">On-demand services</h2>
            <p className="lede">
              Need AWS help right now? Get expert solutions without the
              overhead. Pay only for what you need, when you need it.
            </p>
          </div>
          <div className="ondemand-grid">
            {onDemand.map((service) => (
              <div className="card card-hover ondemand-card" key={service.title}>
                <div className="icon-tile">
                  <Icon name={service.icon} />
                </div>
                <h3 className="h3">{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Offerings;
